import { action } from 'typesafe-actions';
import {
  SafetyMessageAndLogoActionTypes,
  UpdateSafetyMessageAndLogoParams
} from 'types';

export const updateSafetyMessageAndLogoStart = (
  request: UpdateSafetyMessageAndLogoParams
) =>
  action(
    SafetyMessageAndLogoActionTypes.UPDATE_SAFETY_MESSAGE_AND_LOGO_START,
    request
  );

export const updateSafetyMessageAndLogoSuccess = (data: any) =>
  action(
    SafetyMessageAndLogoActionTypes.UPDATE_SAFETY_MESSAGE_AND_LOGO_SUCCESS,
    data
  );

export const updateSafetyMessageAndLogoFailure = (error: any) =>
  action(
    SafetyMessageAndLogoActionTypes.UPDATE_SAFETY_MESSAGE_AND_LOGO_FAILURE,
    error
  );

export const uploadLogoFailure = (error: any) => {
  action(SafetyMessageAndLogoActionTypes.UPLOAD_LOGO_FAILURE, error);
};
